'use strict';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

const Timeline = {
    init: function () {
        this.initScrollTrigger();
        const scrEl = document.querySelector('.f-timeline__container');
        const container = document.querySelector('.f-timeline .container');
        if (scrEl && container) {
            scrEl.addEventListener('scroll', () => {
                if (innerWidth < 991) {
                    let scrolled = (scrEl.scrollLeft / (scrEl.scrollWidth - scrEl.clientWidth)) * 100;
                    if (scrolled > 95) {
                        container.classList.add('completed')
                    } else {
                        container.classList.remove('completed')
                    }
                }
            })
        }
    },
    initScrollTrigger: function () {
        Timeline.scrollLeftTotal = 500;
        gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

        const timeline = document.querySelector('.timeline__section');
        const timelineContainer = document.querySelector('.f-timeline__container');
        const timelineItems = document.querySelectorAll('.js-timeline-item');
        const listAnchorContainer = document.querySelector(".f-timeline__nav");

        if (timelineContainer && timelineItems.length > 0) {
            let mm = gsap.matchMedia();
            mm.add("(min-width: 991px)", () => {
                timelineContainer.style.width = `${timelineItems.length * 100}%`
                let sections = gsap.utils.toArray(".js-timeline-item");
                gsap.to(sections, {
                    xPercent: -100 * (sections.length - 1),
                    ease: "none",
                    scrollTrigger: {
                        trigger: ".f-timeline",
                        start: "center center",
                        pin: true,
                        scrub: 1,
                        // snap: 1 / (sections.length - 1),
                        end: () => "+=" + (Timeline.scrollLeftTotal * timelineItems.length)
                    }
                });
            })

            function getOffsetTop(elem) {
                var offsetTop = 0;
                do {
                    if (!isNaN(elem.offsetTop)) {
                        offsetTop += elem.offsetTop;
                    }
                } while (elem = elem.offsetParent);
                return offsetTop - 50;
            }


            timelineItems.forEach((item, i) => {
                var li = document.createElement('li');
                listAnchorContainer.appendChild(li);
                li.innerHTML = item.querySelector('.f-timeline-date').innerHTML;

                li.addEventListener('click', function (e) {
                    e.preventDefault();
                    let n = timelineItems.length;
                    const scrollToHere = getOffsetTop(timeline) + i * (n * Timeline.scrollLeftTotal / (n - 1));
                    gsap.to(window, {
                        scrollTo: scrollToHere,
                        duration: .1
                    })
                });
            })
        }
    }

};

export default Timeline;
